import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateGroupFooter = (props) => {
  const { mykey } = props.group_data;
  const group_count = props.group_count ?? 0;
  const total_liter = props.total_liter ?? 0;
  const total_harga = props.total_harga ?? 0;

  return (
    <tr
      key={`${mykey}-group-footer-${props.group_label}`}
      className={`row-start-start ${tableWidth} text-sm text-slate-700`}
    >
      <td
        className={`row-start-start w-full border-zinc-300 border border-t-0  px-2 pt-3 pb-3 font-semibold pl-14 gap-10`}
      >
        <span>{group_count.toLocaleString("id-ID")} Kendaraan</span>
        <div className="row-start-start gap-2">
          <span> Jumlah : </span>
          {total_liter.toLocaleString("id-ID")} Ltr
        </div>
        <div className="row-start-start gap-2">
          <span> Total Harga : </span>
          Rp {total_harga.toLocaleString("id-ID")}
        </div>
      </td>
    </tr>
  );
};

export default ReportTemplateGroupFooter;
